var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container__button"},[_c('button',{staticClass:"container__button-close",on:{"click":_vm.btnAbort}},[_c('span',{style:(("font-size: " + _vm.fontSize + "px")),attrs:{"aria-hidden":"true"}},[_vm._v("✕")])])])}
var staticRenderFns = []

export { render, staticRenderFns }